export default __webpack_public_path__ + "static/media/instruction-modal-close.3416afbf.svg";